import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// Achievements
export const getAchievements = (params = {}) => Http.get(`/gamification/achievements${serialize(params)}`)
export const getAchievement = (id) => Http.get(`/gamification/achievements/${id}`)
export const saveAchievement = (params) => Http.post('/gamification/achievements', params)
export const updateAchievement = (id, params) => Http.put(`/gamification/achievements/${id}`, params)
export const deleteAchievement = (id) => Http.delete(`/gamification/achievements/${id}`)

// Achievement Categories
export const getAchievementCategories = (params = {}) => Http.get(`/gamification/achievement-categories${serialize(params)}`)
export const saveAchievementCategory = (params) => Http.post('/gamification/achievement-categories', params)
export const updateAchievementCategory = (id, params) => Http.put(`/gamification/achievement-categories/${id}`, params)
export const deleteAchievementCategory = (id) => Http.delete(`/gamification/achievement-categories/${id}`)

// Missions
export const getMissions = (params = {}) => Http.get(`/gamification/missions${serialize(params)}`)

// MGC Reward Rules
export const getMgcRewardRules = (params = {}) => Http.get(`/gamification/mgc-reward-rules${serialize(params)}`)

// Level Definitions
export const getLevelDefinitions = (params = {}) => Http.get(`/gamification/level-definitions${serialize(params)}`)
